<template>
    <section id="pass-change-successful">
        <b-modal @hide="onHide" id="change-successful" ref="passchngagree" centered hide-header hide-footer>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="pass-change-successful mx-auto">
                            <button
                                @click="$store.commit('TOGGLE_MODAL', ['pass-change', false])"
                                aria-label="Close"
                                id="modal-close"
                                class="close pr-4">
                                    <CloseCross/>
                            </button>
                            <div class="passchng-wrap">
                                <div class="pass-change-successful-form mx-auto">
                                    <div class="col-xs-12">
                                        <div class="passchng-text text-center mt-3">
                                            <p class="p4b">That's it! You successfully <br>reset your password</p>
                                            <img :src="ICON_CHECK" alt="">
                                        </div>
                                    </div>
                                    <div class="col-xs-12">
                                        <div class="form-div pt-5">
                                            <button type="button" @click="backToHome" class="mt-5 d-block w-100 p2b forgot">
                                                Back to Home
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import { CloseCross } from '../components/Icons'
import {ICON_CHECK} from "../constants";

export default {
        name: 'PassChangeSuccessful',
        components: {
            CloseCross
        },
        data: () => ({ ICON_CHECK }),
        mounted: function() {
            this.$bvModal.show(`change-successful`)
        },
        methods: {
            onHide: function(evt) {
                setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['pass-change', false])
                }, 0)
            },
            backToHome: function()  {
                this.$store.commit('TOGGLE_MODAL', ['pass-change', false])
            }

        }
    }

</script>

<style scoped lang="scss">
    div.pass-change-successful {
        width: 450px;
        height: 371px;

        div.passchng-wrap {
            width: 450px;
            height: 370px;
            background: #FFFFFF;
            -webkit-box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
            box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
            border-radius: 5px;

            div.pass-change-successful-form {
                width: 325px;
                padding-top: 52px;

                div.passchng-text {
                    p {
                        color: #00000061;
                        &:first-child {
                            color: #858585;
                        }
                    }
                }
                div.form-div {
                    button {
                        &.forgot {
                            height: 48px;
                            color: #ffffff;
                            background: #727CF5;
                            border-radius: 5px;
                            border: 0;
                            transition: all 0.1s linear;

                            &:hover {
                                box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
                            }
                        }
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 280px) and (max-width: 450px) {
        div.pass-change-successful,
        .passchng-wrap {
            width: 100%;
        }

        div.pass-change-successful-form {
            width: 280px;
        }

        .md-checkbox[data-v-60214417] {
            transform: translate(-10%);
        }
    }

</style>
